'use client';

import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import { Toaster as Sonner } from 'sonner';
import { jsx as _jsx } from "react/jsx-runtime";
export var Toaster = function Toaster(_ref) {
  var props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(Sonner, _objectSpread({
    className: "toaster group",
    position: "top-right"
  }, props));
};